import type { ConciseWorkspace } from '@festina/configuration-general-types/configuration'
import type {
  AllConciseWorkspaces,
  BranchKey,
  WorkspaceKey,
} from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { WorkspaceSwitchOptions } from '../system/useWorkspaceNavigation'
import type { WorkspaceCreateOrUpdateInput } from '../uiModels/workspace/types'
type WorkspaceManagerContext = {
  conciseWorkspaces: AllConciseWorkspaces
  currentWorkspaceKey: Optional<WorkspaceKey>
  getWorkspace: (key: WorkspaceKey) => Optional<ConciseWorkspace>
  onSwitch: (
    nextWorkspace: Optional<WorkspaceKey>,
    options?: WorkspaceSwitchOptions,
  ) => Promise<void>
  onCreate: (
    creationInput: WorkspaceCreateOrUpdateInput,
    shouldUpdateCache?: boolean,
  ) => Promise<void>
  onDelete: (workspace: WorkspaceKey) => Promise<void>
  onUpdate: (
    workspace: WorkspaceCreateOrUpdateInput,
    shouldUpdateCache?: boolean,
  ) => Promise<void>
  onOpenWorkspaceSelector: (lockedToBranch: BranchKey) => void
  revalidateWorkspace: (workspaceKey: WorkspaceKey) => Promise<void>
}

const [useWorkspaceManagerContext, Provider] =
  createRequiredContext<WorkspaceManagerContext>('WorkspaceManager')

export { Provider, useWorkspaceManagerContext }
